const namespace = "inactivityKick";

export const DESCRIPTION = `${namespace}.description`;
export const CLOSE = `${namespace}.close`;
